module.exports = __webpack_public_path__ + "img/05-Sportwagen-Coupé.fc4aa64f.svg";